import {
    MappedPorcentagem,
    TypedPorcentagem,
    formatPorcentagemRegra,
    formatarHoras,
    hoursToMinutes as min,
} from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { usePagamentoHorasOutletContext } from 'pages/PagamentoHoras'
import { useParams } from 'react-router-dom'
import {
    CreateOrUpdatePagamentoHorasSchema,
    CreatePagamentoHoras,
    SaldoHoras,
    pagamentoHoras,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormPagamento from '../forms/FormPagamentoHoras'

export default function EditarPagamento() {
    const empresaId = useStore(state => state.companyId)
    const { mutateAsync, isLoading } = pagamentoHoras.mutations.useCreate({
        invalidateQuery: true,
    })

    const { funcionarioId } = useParams()
    const { data, competencia } = usePagamentoHorasOutletContext()

    const obj = data?.find(
        d => d.pagamento.funcionarioId === Number(funcionarioId),
    )

    if (!funcionarioId || !obj || !competencia) return null
    const { limite, pagamento } = obj

    const handleSubmit = (values: CreatePagamentoHoras) => {
        let key

        const regex = new RegExp('^([0-9]{1,3}):([0-5][0-9])$')

        if (!regex.test(values.horas) || !regex.test(values.faltas)) {
            toast.error('O valor deve ter o formato HHH:mm')
            return new Promise((_, reject) => reject())
        } else if (min(values.horas) > min(limite?.horasExtras)) {
            return new Promise((_, reject) =>
                reject(toast.error('O pagamento não pode superar o limite')),
            )
        } else if ((key = porcentagemPagaSuperaSaldo(values, limite))) {
            toast.error(
                `O valor das horas ${formatPorcentagemRegra(
                    key,
                )} não pode superar o saldo`,
            )
            return new Promise((_, reject) => reject())
        } else if (min(values.faltas) > min(limite?.faltas)) {
            return new Promise((_, reject) =>
                reject(toast.error('O valor não pode superar o saldo')),
            )
        } else
            return mutateAsync(
                {
                    ...values,
                    horas: formatarHoras(values.horas, 3),
                    faltas: formatarHoras(values.faltas, 3),
                    porcentagens: JSON.stringify(values.porcentagens),
                    funcionarioId: Number(funcionarioId),
                    empresaId,
                    competencia,
                },
                {
                    onSuccess: () => {
                        toast.success('Pagamento atualizado!')
                    },
                    onError: err => {
                        toast.error(err.message)
                    },
                },
            )
    }

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={v => handleSubmit(v)}
            schema={CreateOrUpdatePagamentoHorasSchema}
            defaultValues={{
                funcionarioId: Number(funcionarioId),
                empresaId,
                competencia,
                horas: formatarHoras(pagamento?.horas, 3),
                faltas: formatarHoras(pagamento?.faltas, 3),
                porcentagens: pagamento?.porcentagens ?? {},
            }}
            open={hasPermission(['update', 'PagamentoDeHoras'])}
        >
            <Dialog.Title>Gerenciar pagamento</Dialog.Title>
            <Dialog.Content dividers>
                <FormPagamento limite={limite} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}

function porcentagemPagaSuperaSaldo(
    values: CreatePagamentoHoras,
    limite: Partial<SaldoHoras>,
): false | string {
    let k = ''

    if (
        Object.entries(values.porcentagens ?? {}).some(([key, value]) => {
            const porcentagemSaldo = limite
                ? new MappedPorcentagem(
                      limite.porcentagemHorasExtras as TypedPorcentagem,
                  ).get(key)
                : undefined

            if (min(value) > min(porcentagemSaldo ?? '00:00')) {
                k = key
                return true
            } else return false
        })
    )
        return k
    else return false
}
